<template>
  <div>
    <!-- <el-dialog
    :visible="showDialog"
    width="80%"
    class="chartDia"
    @close="close"
    append-to-body
  > -->
    <!-- <div slot="title" class="slotTit" style="text-align:center;">
      累计结算金额
    </div> -->
    <div class="search-box">
      <div class="search-left">
        <div style="margin-right:20px;">
          <span>项目名称:</span>
          <dic-select
            @dic-select-obj="saveProId"
            :fuzzyDef="searchAjaxPro"
            :prop="ProProp"
            ajaxQuery="title"
            :ajaxQueryObj="searchQuery"
          ></dic-select>
        </div>
        <div>
          <span>任务月度:</span>
          <el-date-picker
            @change="dateChange"
            range-separator="-"
            value-format="yyyy-MM"
            type="month"
            v-model="searchQuery.orderMonth"
          ></el-date-picker>
        </div>
      </div>
      <div class="search-right">
        <el-button type="primary" @click="searchEvent">搜索</el-button>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border=""
      style="width: 100%"
      :stripe="true"
      :highlight-current-row="false"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        label="序号"
        type="index"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="projectName"
        label="项目名称"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderMonth"
        label="任务月度"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="finishSum"
        label="已完成任务量"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="hospitalName"
        label="终端结算单价"
      >
        <template slot-scope="{ row }">
          {{ row.taskPrice | moneyFixed }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sumTaskPrice"
        label="终端结算金额"
      >
        <template slot-scope="{ row }">
          {{ row.sumTaskPrice | moneyFixed }}
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="paginationData.pageNum"
      :total="totalElements"
      :page-size="paginationData.pageSize"
      layout="total, prev, pager, next, jumper"
      style="padding:15px"
    ></el-pagination>
    <div>
      累计结算金额：
      {{ totalMoney | moneyFixed }}
    </div>
    <!-- <el-button @click="close" type="primary" style="margin-top:10px;"
      >确认</el-button
    > -->
  </div>
  <!-- </el-dialog> -->
</template>
<script>
import { pageInation } from '@/Mixin/listMixin';
import { comprehensive } from '@/api/ajax';
import datePicker from '@/Mixin/datePicker';
import dicSelect from '@/components/Common/dicSelect';
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: true
    },
    activeId: {
      type: String,
      default: ''
    }
  },
  components: {
    dicSelect
  },
  mixins: [pageInation, datePicker],
  data() {
    return {
      getList: comprehensive.comprehensivePeopleProjectList, // 获取列表的AJAX
      searchAjaxPro: comprehensive.comprehensivePeopleProjectList_Project,
      ProProp: {
        label: 'projectName',
        code: 'project_id'
      },
      searchQuery: {
        peopleOrderId: this.activeId
      },
      totalMoney: ''
    };
  },
  methods: {
    saveProId(val) {
      this.searchQuery.projectId = val.project_id;
    },
    close() {
      this.$parent.componentName = '';
      this.$xrkDialog.remove();
    },
    dateChange(val) {
      this.searchQuery.orderMonth = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.search-box {
  position: relative;
  justify-content: space-around;
  // padding: 15px 0;
  margin-bottom: 2.18vw;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > * {
    margin-right: 10px;
  }

  .search-input,
  .el-date-editor--month,
  .search-select {
    width: 11.66vw;
    max-width: 224px;
    min-width: 149px;
    // margin-right: 1.56vw;
    // height: 4.35vh;
    // max-height: 40px;
    // min-height: 27px;
  }

  .search-select,
  .el-date-editor,
  .el-button,
  .search-input {
    margin-right: 1.56vw;
  }

  .el-button {
    //width: 4.6vw;
    //max-width: 88px;
    min-width: 70px;
  }

  /*搜索 左侧输入框*/
  .search-left {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -15px;
    align-items: flex-start;

    > div {
      margin-bottom: 15px;
      margin-right: 10px;
      > .el-cascader {
        /*解决此元素绝对定位影响父元素高度*/
        height: 40px;
      }
    }

    > div > span {
      width: 42px;
      height: 14px;
      font-size: 0.95em;
      font-weight: 400;
      color: rgba(74, 74, 74, 1);
      line-height: 14px;
      margin-right: 10px;
    }
  }

  /*搜索 右侧按钮盒子*/
  .search-right {
    align-self: normal;
    display: flex;
    align-items: flex-end;

    button {
      margin-right: 20px;
      margin-left: 0px;
    }

    button:last-child {
      margin-right: 0;
    }
  }
}
</style>
